{
  "pricing": {
    "loadingInfo": "Cargando información de precios...",
    "noPriceInfo": "No hay información de precios disponible",
    "takeGoldmakingNextLevel": "Lleva tu generación de oro al siguiente nivel",
    "subscribeFrom": "Suscríbete por solo {{price}} {{currency}} / mes. Sin compromiso. Cancela cuando quieras.",
    "goldSubActive": "Tu suscripción {{type}} actual termina el {{expiration}}",
    "goldSubTitle": "Suscripción Gold activa",
    "goldSubUpgradeTitle": "¿Listo para pasar a Premium?",
    "goldSubHeading": "Bienvenido de nuevo, fabricante de oro",
    "goldSubHeadingSubtitle": "Gracias por ser miembro Gold — aquí tienes tu suscripción de un vistazo.",
    "upgradeToPremiumContact": "Para mejorar a premium contacta a nuestro equipo en el",
    "discordName": "Flipping Pal Discord",
    "manageBilling": "Administrar facturación y métodos de pago",
    "manageBillingOpening": "Abriendo...",
    "monthly": "Mensual",
    "yearly": "Anual",
    "saveUpTo": "Ahorra hasta un {{percent}}% con una suscripción anual.",
    "mostPopular": "Más popular",
    "perMonth": "/mes",
    "perYear": "/año",
    "startDate": "Fecha de inicio: {{date}}",
    "nextPaymentDate": "Próxima fecha de pago: {{date}}",
    "subscriptionEnds": "La suscripción termina: {{date}}",
    "reasonPaymentFailed": "Motivo: Pago fallido",
    "reasonCancelled": "Motivo: Cancelado",
    "accessTools": "Acceder a las herramientas",
    "resumeSubscription": "Reanudar suscripción",
    "cancelSubscription": "Cancelar suscripción",
    "processing": "Procesando...",
    "subscribeNow": "Suscribirse ahora",
    "getStarted": "Comenzar",
    "switchToMonthly": "Cambiar a mensual",
    "switchToYearly": "Cambiar a anual",
    "upgradeToPremium": "Mejorar a Premium",
    "upgradeLabel": "Mejorar a Premium ({{billing}})",
    "downgradeToBasic": "Degradar a Basic",
    "downgradeLabel": "Degradar a Basic ({{billing}})",
    "switchPlan": "Cambiar plan",
    "currentPlan": "Plan actual",
    "statusActive": "Activo",
    "statusExpired": "Expirado",
    "statusCanceled": "Cancelado",
    "statusInCancelation": "En cancelación",
    "showMoreFeatures": "+ {{count}} más funciones",
    "showFewerFeatures": "Mostrar menos"
  },
  "trial": {
    "activatedTitle": "¡Prueba activada!",
    "activatedSubtitle": "Esto es lo que obtienes — y lo que te espera",
    "startExploring": "Comenzar a explorar",
    "viewPlans": "Ver planes",
    "trialActive": "Prueba gratuita activa",
    "daysRemaining": "{{count}} día restante",
    "expires": "Vence el {{date}}",
    "trialLabel": "Prueba",
    "compareButton": "Comparar planes",
    "trialEnded": "Tu prueba gratuita ha terminado. ¡Suscríbete para seguir usando FlippingPal!",
    "haveTrialCode": "¿Tienes un código de prueba?",
    "trialCodeHint": "Usa",
    "trialCodeHint2": "en nuestro",
    "discordServer": "servidor de Discord",
    "trialCodeHint3": "para obtener uno",
    "activateButton": "Activar prueba",
    "activatingButton": "Activando"
  },
  "features": {
    "basic": {
      "0": "Limitado a 10 reinos de venta",
      "1": "Herramienta de housing para hacer flip y dropship de decoración",
      "2": "Herramienta de flipping entre reinos",
      "3": "Herramienta de dropship limitada a 3 resultados por objeto",
      "4": "Estadísticas de reino",
      "5": "Generador de listas TSM",
      "6": "Hasta 50 alertas de snipe para Discord",
      "7": "Presets de filtros limitados a 3",
      "8": "Soporte al cliente del equipo"
    },
    "premium": {
      "0": "Reinos de venta ilimitados",
      "1": "Herramienta de housing para hacer flip y dropship de decoración",
      "2": "Herramienta de flipping entre reinos",
      "3": "Herramienta de dropship aumentada a 10 resultados por objeto",
      "4": "Estadísticas de reino",
      "5": "Generador de listas TSM",
      "6": "Herramienta de análisis de inventario",
      "7": "Hasta 9999 alertas de snipe para Discord",
      "8": "Presets de filtros limitados a 50",
      "9": "Compartir filtros con función de importación/exportación",
      "10": "Soporte al cliente del equipo",
      "11": "Soporte prioritario"
    }
  },
  "loading": "Cargando información de suscripción..."
}
